(function () {
    'use strict';
    var controllerId = 'cndProgetti';
    angular.module('app').controller(controllerId, ['$scope', '$rootScope', 'common', 'bootstrap.dialog', '$routeParams', '$uibModal', 'datacontext', 'sectionMenu', fn_cndProgetti]);

    function fn_cndProgetti($scope, $rootScope, common, bDialog, $routeParams, modal, datacontext, sectionMenu) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');

        var vm = this;
        vm.title = 'CNDProgetti';
        vm.view = 'list';       //Opzione list or detail
        vm.setView = setView;
        vm.sectionMenu = sectionMenu.setSection(vm.title);

        vm.objName = "cndprogetto"; //Utilizzato per pannello authorization
        vm.authorization = {};
        vm.showObjPanel = false;
        vm.record = {};
        vm.records = [];
        vm.countRecords = 0;
        vm.index = 0;
        vm.custom = false;

        vm.exportDisabled = false;
        vm.pageSize = 30;
        vm.page = 1;
        vm.loading = false;

        //Elenco per Ordinamento
        vm.list = {};
        vm.cmblist = {};
        vm.list.ordine = ['', 'Progetto', 'Etichetta', 'finestra', 'data', 'data decr.'];
        vm.ordine = vm.list.ordine[0];
        vm.selectOrdine = function (item) {
            vm.ordine = item;
        };

        vm.cmblist.cndCandidature = jQuery.extend([], datacontext.arrCNDCandidatura());
        vm.cmblist.cndTRuoloCodes = jQuery.extend([], datacontext.arrCNDTRuoloCode());
        vm.cmblist.cndTMisuraCodes = jQuery.extend([], datacontext.arrCNDTMisuraCode());
        vm.cmblist.cndProgettiNames = jQuery.extend([], datacontext.arrCNDProgettoName());


        //Filtro
        vm.filter = {};

        vm.fTestuale = '';
        vm.fCode = '';
        vm.fTMisuraCode = '';
        vm.fTRuoloCode = '';
        vm.fProgetto = '';
        vm.fiTipoCandidatura = 0;
        vm.fData = '';
        vm.fIStato = 0;

        vm.filter.testuale = vm.fTestuale;
        vm.filter.code = vm.fCode;
        vm.filter.tMisuraCode = vm.fTMisuraCode;
        vm.filter.tRuoloCode = vm.fTRuoloCode;
        vm.filter.progetto = vm.fProgetto;
        vm.filter.iTipoCandidatura = vm.fiTipoCandidatura;
        vm.filter.data = vm.fData;

        vm.format = 'dd/MM/yyyy';

        //Metodi su interfaccia
        vm.cerca = cerca;
        vm.activated = false;
        vm.loadMore = getAllByFilter;
        vm.loadAll = getAll;

        vm.goNext = goNext;
        vm.goPrev = goPrev;

        vm.get = getRecord;
        vm.add = addModal;
        vm.update = updateItem;
        vm.delete = deleteItem;

        vm.change_candidatura = change_candidatura;


        //datapicker
        vm.open = function ($event, iOpened) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = false;
            vm.opened2 = false;

            if (iOpened == 1)
                vm.opened1 = true;
            else if (iOpened == 2)
                vm.opened2 = true;
        };

        vm.clear = function ($event, iOpened) {
            if (iOpened == 1) {
                vm.record.DtStart = '';
                vm.changed = true;
            }
            else if (iOpened == 2) {
                vm.record.DtEnd = '';
                vm.changed = true;
            }
        };

        vm.dateOptions = {
            formatYear: 'yyyy',
            formatMonth: 'MM',
            startingDay: 1
        };

        vm.format = 'dd/MM/yyyy';



        // ---- ACTIVATE -------
        activate();

        function activate() {
            var promises = [getAuthorization()];
            common.activateController(promises, controllerId)
                .then(function () {
                    if ($routeParams.CNDProgettoId != null) {
                        setView('detail');
                        getRecord($routeParams.CNDProgettoId, 0);
                    }

                    cerca();
                });
        }


        //****************************************************
        // METODI 
        //****************************************************
        function setView(view) {
            return vm.view = view;
        }

        function cerca() {
            vm.records = [];
            vm.countRecords = 0;
            vm.page = 1;

            vm.filter.testuale = vm.fTestuale == null ? '' : vm.fTestuale;
            vm.filter.code = vm.fCode == null ? '' : vm.fCode;
            vm.filter.tMisuraCode = vm.fTMisuraCode == null ? '' : vm.fTMisuraCode;
            vm.filter.tRuoloCode = vm.fTRuoloCode == null ? '' : vm.fTRuoloCode;
            vm.filter.progetto = vm.fProgetto == null ? '' : vm.fProgetto;
            vm.filter.iTipoCandidatura = vm.fiTipoCandidatura == null ? 0 : vm.fiTipoCandidatura;
            vm.filter.data = vm.fData == null ? '' : vm.fData;

            vm.loading = false;
            vm.activated = true;
            return getAllByFilter();
        }

        function countByFilter() {
            return datacontext.cndProgetto_countAll(vm.filter.testuale, vm.filter.code, vm.filter.tMisuraCode, vm.filter.tRuoloCode, vm.filter.progetto, vm.filter.iTipoCandidatura, vm.filter.data).then(function (data) {
                if (data) {
                    vm.countRecords = data;
                }
            });
        }

        function getAllByFilter() {
            if (!vm.activated) return;
            if (vm.loading === true) return;

            if (vm.countRecords == 0) countByFilter();
            else if (vm.countRecords <= vm.records.length) return;

            vm.loading = true;
            return datacontext.cndProgetto_getAll(vm.pageSize, vm.page, vm.filter.testuale, vm.filter.code, vm.filter.tMisuraCode, vm.filter.tRuoloCode, vm.filter.progetto, vm.filter.iTipoCandidatura, vm.filter.data, vm.ordine).then(function (data) {
                if (data.constructor === Array) {
                    vm.page++;
                    data.forEach(function (item) {
                        vm.records.push(item);
                    });
                }
                vm.loading = false;
            });
        }

        function getAll() {
            if (vm.records.length < vm.countRecords) {
                getAllByFilter().then(function () { getAll(); });
            }
        }

        function getAuthorization() {
            return $rootScope.getAuthorization(vm, vm.objName).then(function (data) {
                //Auth. specifica
                //vm.isSpecial = (vm.isSUPER || vm.isUMC || vm.isCIAPI);
            });
        }

        function getRecord(id, index) {
            return datacontext.cndProgetto_get(id).then(function (data) {
                vm.index = index;
                vm.record = data;

                if (vm.record.DtStart != null) vm.record.DtStart = new Date(vm.record.DtStart);
                if (vm.record.DtEnd != null) vm.record.DtEnd = new Date(vm.record.DtEnd);
                if (vm.record.DtEndCPI != null) vm.record.DtEndCPI = new Date(vm.record.DtEndCPI);

                
                console.info('vm.record', vm.record);
                setView('detail');
            });
        }

        function goNext() {
            if (vm.index + 1 >= vm.countRecords) return;

            if (vm.index + 1 >= vm.records.length && vm.index + 1 < vm.countRecords) {
                getAllByFilter();
            }
            if (!vm.records) return;

            vm.index++;
            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        function goPrev() {
            if (vm.index == 0) return;
            if (!vm.records) return;

            vm.index--;

            return getRecord(vm.records[vm.index].Id, vm.index);
        }

        function addRecord(id) {
            return datacontext.videoGuida_getDto(id).then(function (data) {
                vm.records.push(data);
                vm.countRecords++;
            });
        }

        function updateItem() {
            return datacontext.cndProgetto_update(vm.record).then(function (data) {
                if (!data || data == "404")
                    return logError('Errore durante l\'aggiornamento del dato ');

                vm.record = data;
                vm.records[vm.index] = vm.record;
                logSuccess('Record Salvato ');
            });
        }


        function deleteItem(item) {
            var msg = 'progetto: ' + item.Id;
            bDialog.deleteDialog(msg).then(function () {
                return datacontext.cndProgetto_delete(item.Id).then(function (data) {
                    if (data != "204") return logError('Errore cancellazione dati [' + data + ']');

                    var index = vm.records.indexOf(item)
                    vm.records.splice(index, 1);
                    vm.countRecords--;
                });
            });
        }


        function change_candidatura(cndId) {
            vm.record.ControllerCandidatura = '';
            if (cndId && cndId > 0) {
                var cnd = _.find(vm.cmblist.cndCandidature, function (o) { return o.Id == cndId; });
                if (cnd && cnd != null) {
                    console.info('cnd', cnd);
                    vm.record.ControllerCandidatura = cnd.Name;
                }
            }
        }

        
        //****************************************************
        // OPEN MODAL DIALOG
        //****************************************************
        function addModal() {
            console.log('addModal');

            var modalInstance = modal.open({
                templateUrl: '/app/CND/CNDProgetto/modal/cndProgettoAdd.html?version=127',
                controller: 'cndProgettoAdd',
                backdrop: 'static',
                resolve: {
                    cndCandidature: function () {
                        return vm.cmblist.cndCandidature;
                    },
                    cndTRuoloCodes: function () {
                        return vm.cmblist.cndTRuoloCodes;
                    },
                    cndTMisuraCodes: function () {
                        return vm.cmblist.cndTMisuraCodes;
                    },
                    cndProgettiNames: function () {
                        return vm.cmblist.cndProgettiNames;
                    },
                    Default: function () {
                        return 'avviso5';
                    }
                }
            });

            modalInstance.result.then(function (returnItem) {
                if (returnItem == "400")
                    return logError('Errore durante la creazione del dato ');
                if (returnItem == "409")
                    return logError("Errore Duplicato. videoGuida gia' inserita");

                logSuccess('Record creato con successo ');
                addRecord(returnItem.Id);
            });
        };

        

    }
})();
